import { useUrlSearchParams, useBrowserLocation } from '@vueuse/core';

/**
 * 获取入口 url 参数值
 * @param key {string} 需要获取的参数名
 */
export const getEntryUrlParamValue = (key: string): string => {
  // url有两种形式：
  // 1、/xxx/corpId/x/agentId/x
  // 2、xxx?currentCorpId=x&agentId=x

  const currentPath = useBrowserLocation().value?.pathname;
  const params = useUrlSearchParams('history');

  let value = '';

  switch (key) {
    case 'currentCorpId':
      value = getCurrentCorpId(currentPath, params);

      break;
    case 'agentId':
      value = getAgentId(currentPath, params);
      break;
    case 'staffId':
      value = getStaffId(params);
      break;
    default:
      value = '';
      break;
  }

  return value;
};

/**
 * 获取 currentCorpId 值
 * @param currentPath {string} 当前 url path
 * @param params {object} 当前 url params
 */
const getCurrentCorpId = (currentPath = '', params): string => {
  // 如果 path 有值，则返回该值；否则从 params 获取
  if (currentPath?.split('/')?.[2] === 'corpId') return currentPath?.split('/')?.[3];

  // 如果参数值为数组，返回第一个值
  if (Array.isArray(params.currentCorpId) && params.currentCorpId[0]) return params.currentCorpId[0];

  // 如果为字符串 'undefined' 或字符串 'null'，返回空字符
  if (params.currentCorpId === 'undefined' || params.currentCorpId === 'null') return '';

  // 如果为其他字符串，返回该值
  if (typeof params.currentCorpId === 'string') return params.currentCorpId;

  // 如果以上条件都不满足，返回空字符串
  return '';
};

/**
 * 获取 agentId 值
 * @param currentPath {string} 当前 url path
 * @param params {object} 当前 url params
 */
const getAgentId = (currentPath = '', params): string => {
  // 如果 path 有值，则返回该值；否则从 params 获取
  if (currentPath?.split('/')?.[4] === 'agentId') return currentPath?.split('/')?.[5];

  // 如果参数值为数组，返回第一个值
  if (Array.isArray(params.agentId) && params.agentId[0]) return params.agentId[0];

  // 如果为字符串 'undefined' 或字符串 'null'，返回空字符
  if (params.agentId === 'undefined' || params.agentId === 'null') return '';

  // 如果为其他字符串，返回该值
  if (typeof params.agentId === 'string') return params.agentId;

  // 如果以上条件都不满足，返回空字符串
  return '';
};

/**
 * 获取 staffId 值
 * @param params {object} 当前 url params
 */
const getStaffId = (params): string => {
  // 如果参数值为数组，返回第一个值
  if (Array.isArray(params.staffId) && params.staffId[0]) return params.staffId[0];

  // 如果为字符串 'undefined' 或字符串 'null'，返回空字符
  if (params.staffId === 'undefined' || params.staffId === 'null') return '';

  // 如果为其他字符串，返回该值
  if (typeof params.staffId === 'string') return params.staffId;

  // 如果以上条件都不满足，返回空字符串
  return '';
};
